module.exports = __webpack_public_path__ + "img/video_7.51c34f67.png";